import React from 'react';

import { DeviceFilter } from './filters';

const DrawerDevicePanel = () => <DeviceFilter />;

export default DrawerDevicePanel;
